<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :liveSearching="true"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/contract_reminder";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "name",
      "area",
      "area_section",
      // "system_class",
      // "system_subclasses",
      "updated_admin",
      "updated_at",
    ],
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "篩選子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
    ],
  }),
};
</script>

<style>
</style>